/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateParameterValidationRequest {
    getFixupPrototypeFunction() { return TemplateParameterValidationRequest.fixupPrototype; }

    static newInstance(model: Partial<TemplateParameterValidationRequest>): TemplateParameterValidationRequest {
        let obj = Object.assign(new TemplateParameterValidationRequest(), model);
        TemplateParameterValidationRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateParameterValidationRequest>): TemplateParameterValidationRequest {
        if (!model) return null;
        return TemplateParameterValidationRequest.newInstance(<TemplateParameterValidationRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateParameterValidationRequest) {
        if (!obj) return;

        models.TemplateParameterValidationRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateParameterValidationRequest): boolean {
        Object.setPrototypeOf(obj, TemplateParameterValidationRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Template execution parameters, encoded as a JSON string
     */
    input_parameters: string;

}
